import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'bp_results';
export const route = 'results/[cities]/[searchParams]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SemResultsPage')));